/**
 Project	IAM - Validation

 @file 	    user-list-fields.model.ts
 @author  	Martin Tazlari <martin.tazlari@ictvs.ch>
 @copyright © 2018, ICT-vs. All rights reserved.
 **/

export class UserListfields {
  type: string;
  Responder: string;
  Title: string;
  usertitle: string;
  firstname: string;
  lastname: string;
  birthday: string;
  avs: string;
  SettlementGroup: string;
  gender: string;
  language: string;
  mobilephone: string;
  recoveryEmail: string;
  address: string;
  npa: string;
  locality: string;
  canton: string;
  Status: string;
  roles: string;
}
